import React from 'react';
import styled from "styled-components";
import colors from '../../styles/colors';
import search from '../../images/search.svg';
import remove from "../../images/remove.svg";
import {BlueButton} from "../Button";
import en from "../../locales/en/translation.json";
import spn from "../../locales/sp/translation.json";
import swe from "../../locales/sw/translation.json";

// let mainLanguage = window.localStorage.getItem('language');
const SearchContainer = styled.div`
  padding: 0rem 1rem 1rem;
  background-color: ${colors.first};
`;

const SearchInput = styled.input`
  width: 100%;
  height: 2rem;
  background-color: ${colors.bright};
  background-image: url(${search});
  background-position: 0.5rem center;
  background-repeat: no-repeat;
  background-size: 1rem;
  padding: 0rem 1rem 0rem 1.875rem;
  font-size: 1rem;
  border-radius: 0.9rem;
  border: 1px solid ${colors.first};
  outline: none;
  color: ${colors.dark};
  -webkit-appearance: textfield;

  &::placeholder {
    color: ${colors.light};
  }
`;

const Hits = styled.ol`
  margin: 0;
  padding: 0;
  font-size: 1rem;
`;

const Hit = styled.li`
  display: flex;
  flex-direction: row;
  align-items: center;
  line-height: 1.5;
  list-style-type: none;
  background-color: ${colors.bright};
  color: ${colors.first};
  border-bottom: 1px solid #cccccc;
  padding: 0.5rem 1.75rem;
  cursor: pointer;
  // &:first-child {
  //   background-color: #f0f0f0;
  // }
`;


const Container = styled.div`
  width: 100%;
`;
const ImageContainer = styled.div`
  width: 100%;
  text-align: center;
`;

const SecondaryAction = styled.div`
`;

const ItemText = styled.div`
  width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  text-transform: capitalize;
  font-size: 1rem;
  font-weight: 500;
  color: ${colors.dark};
  line-height: 1.3;
`;

const ItemDescription = styled.div`
  width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  font-size: 0.875rem;
  font-weight: 500;
  color: ${colors.middle};
  line-height: 1.3;
`;
const ParticularExercise = styled.img`
  height: 50px;
  width: 50px;
`;
const ItemSelectedAction = styled.div`
  display: flex;
  width: 100%;
  justify-content:flex-end;
`;

const ItemIcon = styled.img`
  height: 1.5rem;
`;
const DeleteButton = props => {
    return <ItemIcon src={remove} alt="Ta bort övning" onClick={props.onClick}/>;
};
const SearchBox = (props) => {
    return (
        <SearchContainer>
            <SearchInput
                innerRef={props.setSearchBoxRef}
                type={"search"}
                value={props.value}
                onChange={props.onChange}
                onKeyDown={props.onArrowKeys}
                tabIndex={0}
                placeholder={props.placeholder}
                autoFocus
            />
        </SearchContainer>
    );
};


const SearchHits = (props) => {

    return (
        <Hits>
            {props.hits.map((hit, index) => {

                return (
                    React.cloneElement(props.children, {
                        key: hit.id,
                        id: hit.id,
                        programName: hit.programName,
                        displayName: hit.displayName,
                        name: hit.name,
                        description: hit.description,
                        steps: hit.steps,
                        published: hit.published,
                        sent: hit.sent,
                        index: index,
                        originalId: hit.originalId,
                        userId: hit.userId
                    })
                );
            })}
        </Hits>
    );
};

const SearchHit = (props) => {
    return (
        <>
            {props.programHit && (props.currentUser === props.userId) ?
                <Hit id={props.id} onClick={props.onClick}>
                    <Container>
                        <ItemText>
                            {props.name}
                        </ItemText>
                        <ItemDescription>{props.description}</ItemDescription>
                    </Container>
                    {(props.published === false && props.sent === false) &&
                    <ItemSelectedAction>
                        <DeleteButton onClick={(event) => props.onDeleteDrafts(event, props.index, props.originalId)}/>
                    </ItemSelectedAction>}
                </Hit>
                : props.instructionHit && (props.userId === props.masterUserId || props.userId === props.mainId || props.userId === props.clientEmail) ?
                    <Hit id={props.id} onClick={props.onClick}>
                        <Container>
                            <ItemText>
                                {props.name}
                            </ItemText>
                            <ItemDescription>{props.description}</ItemDescription>
                        </Container>
                        <ImageContainer>
                            {props.onDetailsClick != null ?
                                props.steps.map((exerciseImage) => {
                                    if (exerciseImage.image !== "") {
                                        // let stringUrl = (exerciseImage.image.indexOf("data:image/") === 0 || exerciseImage.image.indexOf("https://") === 0) ? true : false;
                                        return (
                                            <>
                                                <ParticularExercise
                                                    src={exerciseImage.image}
                                                    alt="Ta bort övning"
                                                />
                                            </>
                                        )
                                    } else {
                                    }
                                }) : null}
                        </ImageContainer>
                        {(props.userId === props.mainId) &&
                        <BlueButton onClick={(event) => {
                            props.onEditExercise(event)
                        }}>
                            {/*Redigera*/}
                            {props.mainLanguage === 'English' ? en.Redigera : props.mainLanguage === 'Spanish' ? spn.Redigera : swe.Redigera}
                        </BlueButton>
                        }
                        <SecondaryAction onClick={props.onDetailsClick}>&gt;</SecondaryAction>
                    </Hit> :
                    props.usersHit ?
                        <Hit id={props.id} onClick={props.onClick}>
                            <Container>
                                <ItemText>
                                    {props.name}
                                </ItemText>
                                <ItemDescription>{props.description}</ItemDescription>
                            </Container>
                        </Hit>
                        : ''
            }
        </>
    );
};

export {
    SearchBox,
    SearchHits,
    SearchHit,
}



// WEBPACK FOOTER //
// ./src/Components/Search/index.js